import { render, staticRenderFns } from "./LoginRemain.vue?vue&type=template&id=0b9234d4&scoped=true&"
import script from "./LoginRemain.vue?vue&type=script&lang=js&"
export * from "./LoginRemain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9234d4",
  null
  
)

export default component.exports